import { type EditorValue, parseDraftString } from '@octopus-do/octopus-editor'
import type { ID } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { shallowEqual, useSelector } from 'react-redux'

export const useSymbolContent = (id: ID) => {
  const { colorId, content, title } = useSelector(
    migrationProjectSelector.getProjectSymbolData(id),
    shallowEqual
  )

  const color = useSelector(migrationProjectSelector.getColorById(colorId))

  //todo: support multiple content types in core
  const value =
    typeof content === 'string'
      ? parseDraftString(content)
      : (content as unknown as EditorValue)

  return {
    color: color?.hexCode || '#2F7FEF',
    content: value,
    title,
  }
}
